import React, { useState } from "react";
import { GetChannelImage } from "src/app/shared/helpers/img-helpers/ImgHelper";
import { IContactCommunicationItemProps } from "./~types/ContactCommunicationItemProps";

import "./ContactCommunicationItem.css"
import { IMessenger } from "src/app/contact/~store/models/Messenger";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ChannelType } from "src/app/contact/~store/models/ChannelType";
import { Button, Input } from "reactstrap";
import Accordion from "@mui/material/Accordion";
import { useTranslation } from 'react-i18next';

const ContactCommunicationItem = (props: IContactCommunicationItemProps) => {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState<boolean>(props.messenger.messengerId === 0)
    const [editingMessenger, setEditingMessenger] = useState<IMessenger>({...props.messenger})

    const onChannelNameChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedChannel = props.allChannels.find(ch => ch.channelId === +e.currentTarget.value)
        
        if(selectedChannel) {
            setEditingMessenger({...editingMessenger, channelId: selectedChannel.channelId, channelModel: selectedChannel});
        }
    }

    const onExternalIdChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditingMessenger({...editingMessenger, externalId: e.currentTarget.value.trim()})
    }
    
    const onNicknameChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditingMessenger({...editingMessenger, nickName: e.currentTarget.value.trim()})
    }

    const onSaveMessenger = () => {
        props.onSaveMessenger(editingMessenger);
        setIsEditing(false);
    }

    const onReplayButtonClicked = () => {
        if(props.messenger.messengerId === 0) {
            props.onDetachMessenger(props.messenger)
        }
        else {
            setIsEditing(false)
        }
    }

    const _mapChannelNameSector = () => {
        return (
            isEditing ?
                <select className="contact-communication__channel-name-select" value={editingMessenger.channelId} onChange={onChannelNameChanged}>
                    {props.allChannels.map((chnl, indx) => {
                        return(
                            <option key={indx} value={chnl.channelId}>{chnl.name}</option>
                        )
                    })}
                </select> :
                props.messenger.channelModel.name
        )
    }

    const _mapNumberSector = () => {
        return (
            isEditing ?
                <Input
                    value={editingMessenger.externalId} 
                    onChange={onExternalIdChanges}
                />:
                 props.messenger.externalId
        )
    }

    const _mapNicknameSector = () => {
        return (
            isEditing && !props.messenger.externalId ?
                <Input
                    value={editingMessenger.nickName} 
                    onChange={onNicknameChanges}
                />:
                 props.messenger.nickName
        )
    }

    const isOdd = props.rowIndex % 2 === 1;
    
    return (
        <>
            <tr key={props.messenger.messengerId}
                className={`contact-communication-row ${isOdd ? "odd" : "even"}`}
                data-testid="contact-communication-row"
                data-messenger-id={props.messenger?.messengerId}>
                <td className="contact-communication-column"> 
                    {_mapChannelNameSector()}
                </td>
                <td className="contact-communication-column">
                    {_mapNumberSector()}
                </td>
                <td className="contact-communication-column">
                    {_mapNicknameSector()}
                </td>
                <td>
                    <img 
                        className="contact-messenger__icon"
                        onClick={() => isEditing ? null : props.onNewChatWithMessenger(props.messenger)}
                        src={GetChannelImage(isEditing ? editingMessenger.channelModel.type : props.messenger.channelModel.type)} 
                        width={50} 
                        height={50} />
                </td>
                <td className="contact-account-item__actions">
                    {isEditing ? 
                    <React.Fragment>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-save"
                            data-testid="contact-communication-save"
                            disabled={editingMessenger.externalId.trim().length === 0 && 
                                (editingMessenger.channelModel.type !== ChannelType.TelegramPrivate || editingMessenger.nickName.trim().length === 0)}
                            onClick={() => onSaveMessenger()}>
                                <i className="material-icons">save</i>
                        </Button>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-delete"
                            data-testid="contact-communication-cancel"
                            onClick={onReplayButtonClicked}>
                                <i className="material-icons">replay</i>
                        </Button>
                    </React.Fragment> :
                    <React.Fragment>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-edit"
                            data-testid="contact-communication-edit"
                            onClick={() => setIsEditing(true)}>
                                <i className="material-icons">edit</i>
                        </Button>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-delete"
                            data-testid="contact-communication-detach"
                            disabled={props.messengersCount === 1}
                            onClick={() => props.onDetachMessenger(props.messenger)}>
                                <i className="material-icons">delete_forever</i>
                        </Button>
                    </React.Fragment>}
                </td>
            </tr>
            {
                editingMessenger.firstDeviceInfo &&
                <tr key={`${props.messenger.messengerId}-device-info`}
                    className={`contact-communication-row__device-info ${isOdd ? "odd" : "even"}`}>
                    <td colSpan={5}>
                        <Accordion className="device-accordion">
                            <AccordionSummary expandIcon={<ExpandMoreIcon/>} className="device-accordion__header">
                                <b>{t("contact.firstMessengerDevice")}</b>
                            </AccordionSummary>
                            <AccordionDetails className="device-accordion__details">
                                <ul className="device-accordion-details__properties-list">
                                    <li>
                                        <b>{t("common.device")}:</b> {editingMessenger.firstDeviceInfo.device}
                                    </li>
                                    <li>
                                        <b>{t("common.browser")}:</b> {editingMessenger.firstDeviceInfo.browser}; {editingMessenger.firstDeviceInfo.browserVersion}
                                    </li>
                                </ul>
                            </AccordionDetails>
                        </Accordion>
                    </td>
                </tr>

            }
        </>
    )
}

export default ContactCommunicationItem;